export function sample(arr) {
    const n = arr.length;
    if (n === 0)
        return undefined;
    return arr[Math.floor(Math.random() * n)];
}
